import { Flex, FlexProps } from '@cmpsr/components';

type FooterQuestionnaireProps = FlexProps;

export default function FooterQuestionnaire(props: FooterQuestionnaireProps): React.ReactElement {
  return (
    <Flex
      as="footer"
      backgroundImage="url('/images/footer-questionnaire_3840px.svg')"
      width="100%"
      height="200px"
      flexShrink="0"
      {...props}
    />
  );
}
